export class CommissionAdditionalCredit {
    public idCommissionAdditionalCredit?:number;
    public nombreCliente?:string;
    public idCredito?:number;
    public producto:string;
    public nombreSocio:string;
    public estatusDAP:string;
    public tipoPromocion:string;
    public periodoPago:string;
    public plazo:number;
    public montoPagoCredito:number;
    public idGerente:string;
    public nombreGerente:string;
    public idSupervisor:string;
    public nombreSupervisor:string;
    public idPromotor:string;
    public nombrePromotor:string;
    public fechaCobrado:string;
    public montoSolicitado:string;
    public capital:string;
    public dependencia:string;
    public folioSolicitud:string;
    public nombreSucursal:string;
    public idSucursal:number;
    public estado:string;
    public zona:string;
    public colectivo:string;
    public tipoPromotor:string;
    public montoComision:number;
    public porcentajeComision:number;
    public createdDate:string;
    public createdUser:string;   
    public isSimulate:number;
    public enviado:number;
    public executionDate:string;

}